enum Events {
  // ЗАВЕДЕНИЕ
  REST_NAME = 'Название заведения',

  // СКАН QR
  SCAN_QR = 'Скан QR',

  // ЗАКАЗ
  ORDER = 'Заказ',

  // ОПЛАТА
  PAYMENT = 'Оплата',
  SEPARATE_BILL = 'Раздельный счет',
  TIPS = 'Чаевые',
  CHOICE_BANK = 'Выбор банка',
  COMPLETE_PAYMENT = 'Успешная оплата',

  // МЕНЮ
  MENU = 'Меню',

  // ВЫЗОВ ОФИЦИАНТА
  CALL_WAITER = 'Вызов официанта',

  // ПОДЕЛИТЬСЯ СЧËТОМ
  SHARE_BILL = 'Поделиться счётом',

  // КОРЗИНА
  CART = 'Переход в корзину',
  CHOICE_ITEM_FOR_CART = 'Выбор позиции',
  CART_CALL_WAITER = 'Вызов офцианта из корзины'
}

export default Events
